import { render, staticRenderFns } from "./latest-data-import.vue?vue&type=template&id=898cb092"
import script from "./latest-data-import.vue?vue&type=script&lang=js"
export * from "./latest-data-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports